(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["0-dog-quiz"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  (function () {
    const DAILY = {
      'under-25': 0.5,
      '25-50': 1,
      '50-75': 2,
      '75-100': 3,
      '100-plus': 4
    };

    const WEIGHT_LABELS = {
      'under-25': 'under 25 lbs',
      '25-50':    '25–49 lbs',
      '50-75':    '50–74 lbs',
      '75-100':   '75–99 lbs',
      '100-plus': '100–125 lbs'
    };

    const WEIGHTS = [
      { value: 'under-25', label: 'Under 25 lbs' },
      { value: '25-50',    label: '25–49 lbs' },
      { value: '50-75',    label: '50–74 lbs' },
      { value: '75-100',   label: '75–99 lbs' },
      { value: '100-plus', label: '100–125 lbs' }
    ];

    const ORDINALS = ['first', 'second', 'third'];

    function chewLabel(n) {
      if (n === 0.5) return '½ chew';
      return n === 1 ? '1 chew' : n + ' chews';
    }

    function recommend(totalDaily) {
      // Each bag = 60 chews. Cadence chosen to minimise shipments.
      if (totalDaily <= 0.5) return { bags: 1, cadence: 'every 4 months' }; // ½ chew/day × 120 days = 60 chews
      if (totalDaily <= 1)   return { bags: 1, cadence: 'every 2 months' }; // 1 chew/day  × 60 days  = 60 chews
      if (totalDaily <= 3)   return { bags: Math.ceil(totalDaily), cadence: 'every 2 months' }; // e.g. 2→2 bags, 3→3 bags
      return { bags: Math.ceil(totalDaily / 2), cadence: 'monthly' };       // e.g. 4→2 bags/month
    }

    class DogQuiz {
      constructor(el) {
        this.el = el;
        this.id = el.dataset.sectionId;
        this.count = 1;

        this.teaser = el.querySelector('[data-quiz-teaser]');
        this.body   = el.querySelector('[data-quiz-body]');

        el.querySelector('[data-quiz-start]').addEventListener('click', () => this.start());
        el.querySelector('[data-quiz-cancel]').addEventListener('click', () => this.reset());
        el.querySelector('[data-quiz-restart]').addEventListener('click', () => this.reset());

        el.querySelectorAll('[data-count]').forEach(pill => {
          pill.addEventListener('click', () => {
            el.querySelectorAll('[data-count]').forEach(p => p.classList.remove('is-active'));
            pill.classList.add('is-active');
            this.count = parseInt(pill.dataset.count, 10);
            const nextBtn = el.querySelector('[data-step="count"] [data-next-to]');
            if (nextBtn) nextBtn.disabled = false;
          });
        });

        el.querySelectorAll('[data-next-to]').forEach(btn => {
          btn.addEventListener('click', () => {
            const to = btn.dataset.nextTo;
            if (to === 'profiles') this.goProfiles();
            else if (to === 'results') this.goResults();
          });
        });

        el.querySelectorAll('[data-go-step]').forEach(btn => {
          btn.addEventListener('click', () => this.showStep(btn.dataset.goStep));
        });
      }

      start() {
        this.teaser.hidden = true;
        this.body.hidden   = false;
        this.showStep('count');
      }

      reset() {
        this.teaser.hidden = false;
        this.body.hidden   = true;
        this.el.querySelectorAll('[data-count]').forEach(p => p.classList.remove('is-active'));
        const nextBtn = this.el.querySelector('[data-step="count"] [data-next-to]');
        if (nextBtn) nextBtn.disabled = true;
        this.count = 1;
      }

      showStep(name) {
        this.el.querySelectorAll('.sqsh-quiz__step').forEach(s => {
          s.hidden = s.dataset.step !== name;
        });
      }

      goProfiles() {
        this.buildProfiles();
        this.showStep('profiles');
        const titleEl = this.el.querySelector('[data-step="profiles"] .sqsh-quiz__step-q');
        if (titleEl) titleEl.textContent = this.count === 1 ? 'Tell us about your dog' : 'Tell us about your dogs';
      }

      buildProfiles() {
        const wrap = this.el.querySelector('[data-profiles-wrap]');
        wrap.innerHTML = Array.from({ length: this.count }, (_, i) => `
          <div class="sqsh-quiz__profile">
            <p class="sqsh-quiz__profile-label">${this.count > 1 ? 'Your ' + ORDINALS[i] + ' dog' : 'Your dog'}</p>
            <div class="sqsh-quiz__field">
              <label class="sqsh-quiz__field-label" for="qname-${this.id}-${i}">Dog's name</label>
              <input class="sqsh-quiz__input" id="qname-${this.id}-${i}" data-dog-name="${i}" type="text" placeholder="e.g. Biscuit" autocomplete="off" />
            </div>
            <div class="sqsh-quiz__field">
              <span class="sqsh-quiz__field-label">Weight</span>
              <div class="sqsh-quiz__weights">
                ${WEIGHTS.map(w => `
                  <label class="sqsh-quiz__weight-opt">
                    <input type="radio" name="qweight-${this.id}-${i}" value="${w.value}" data-dog-weight="${i}" />
                    ${w.label}
                  </label>`).join('')}
              </div>
            </div>
          </div>`).join('');
      }

      getDogs() {
        return Array.from({ length: this.count }, (_, i) => {
          const nameEl   = this.el.querySelector(`[data-dog-name="${i}"]`);
          const weightEl = this.el.querySelector(`input[data-dog-weight="${i}"]:checked`);
          return { name: (nameEl?.value?.trim() || ('Dog ' + (i + 1))), weight: weightEl?.value || null };
        });
      }

      goResults() {
        const dogs = this.getDogs();
        const missing = dogs.findIndex(d => !d.weight);
        if (missing > -1) {
          this.el.querySelectorAll('.sqsh-quiz__profile')[missing]
            ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        const totalDaily = dogs.reduce((s, d) => s + DAILY[d.weight], 0);
        const rec        = recommend(totalDaily);
        const bagWord    = rec.bags === 1 ? 'bag' : 'bags';

        const dogLines = dogs.map(d =>
          `<p class="sqsh-quiz__result-dog"><strong>${d.name}</strong> (${WEIGHT_LABELS[d.weight]}) gets ${chewLabel(DAILY[d.weight])} daily.</p>`
        ).join('');

        const wrap = this.el.querySelector('[data-results-wrap]');
        wrap.innerHTML = `
          <div class="sqsh-quiz__result-dogs">${dogLines}</div>
          <p class="sqsh-quiz__result-rec">We recommend <strong>${rec.bags} ${bagWord} ${rec.cadence}</strong> in one shipment.</p>`;

        this.showStep('results');
        this.saveCart(dogs, rec);
      }

      async saveCart(dogs, rec) {
        const attrs = { 'Quiz: Dogs': String(dogs.length) };
        dogs.forEach((d, i) => {
          attrs[`Quiz: Dog ${i + 1} name`]   = d.name;
          attrs[`Quiz: Dog ${i + 1} weight`] = WEIGHT_LABELS[d.weight];
        });
        attrs['Quiz: Recommended bags']     = String(rec.bags);
        attrs['Quiz: Recommended cadence']  = rec.cadence;
        try {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        } catch (_) { /* silent */ }
      }
    }

    document.querySelectorAll('.sqsh-dog-quiz').forEach(el => new DogQuiz(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["0-polaroids-section"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  class SqshPolaroidStack extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.sqsh-polaroid'));
      if (!this.cards.length) return;

      const startIndex = this.cards.findIndex((c) => c.classList.contains('is-active'));
      this.idx = startIndex > -1 ? startIndex : 0;
      this.activate(this.idx);

      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.intervalMs = (parseFloat(this.getAttribute('interval')) || 4) * 1000;

      this.onEnter = () => this.stop();
      this.onLeave = () => this.maybeStart();
      this.onSelect = (e) => {
        const card = e.target.closest('.sqsh-polaroid');
        const i = this.cards.indexOf(card);
        if (i > -1) {
          this.stop();
          this.activate(i);
        }
      };
      this.onDeselect = () => this.maybeStart();

      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      document.addEventListener('shopify:block:select', this.onSelect);
      document.addEventListener('shopify:block:deselect', this.onDeselect);

      this.maybeStart();
    }

    maybeStart() {
      if (!this.reduce && this.cards.length > 1) this.start();
    }

    activate(i) {
      this.cards.forEach((c, n) => c.classList.toggle('is-active', n === i));
      this.idx = i;
    }

    next() {
      this.activate((this.idx + 1) % this.cards.length);
    }

    start() {
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.intervalMs);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('shopify:block:select', this.onSelect);
      document.removeEventListener('shopify:block:deselect', this.onDeselect);
    }
  }

  if (!customElements.get('sqsh-polaroid-stack')) {
    customElements.define('sqsh-polaroid-stack', SqshPolaroidStack);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.top) {
        // Dead zone: scrolling up but between header top and bottom — reveal anyway
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
